import React, { useEffect, useState } from "react";
import "./galerijapage.css";



export default function GalerijaPage() {
  const [blocks, setBlocks] = useState([]);
  const [title, setTitle] = useState("");
  const [intro, setIntro] = useState("");
  const [images, setImages] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  const touchStartX = React.useRef(null);

  const [dragX, setDragX] = useState(0);
  const [isDragging, setIsDragging] = useState(false);

  const [isDesktop, setIsDesktop] = useState(
    window.innerWidth > 768
  );

  // resize detect
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };

    window.addEventListener("resize", handleResize);
    return () =>
      window.removeEventListener("resize", handleResize);
  }, []);

  // fetch WP data
  useEffect(() => {
    const fetchData = async () => {
      const res = await fetch(
        "https://carboncro.hr/wp-json/wp/v2/pages/128?_embed"
      );
      const data = await res.json();

      setTitle(data.title.rendered);

      const parser = new DOMParser();
      const doc = parser.parseFromString(
        data.content.rendered,
        "text/html"
      );

      const result = [];
      const imgs = [];

      doc
        .querySelectorAll("h2, h3, p, figure img, img")
        .forEach((el) => {
          if (el.tagName === "H2" || el.tagName === "H3") {
            result.push({
              type: "title",
              text: el.innerText,
            });
          }

          if (el.tagName === "P") {
            result.push({
              type: "text",
              text: el.innerText,
            });
          }

          if (el.tagName === "IMG") {
            result.push({
              type: "image",
              src: el.src,
            });

            imgs.push(el.src);
          }
        });

      setBlocks(result);
      setImages([...new Set(imgs)]);

      const firstP = doc.querySelector("p");
      if (firstP) setIntro(firstP.innerText);
    };

    fetchData();
  }, []);

  // navbar hide/show
  useEffect(() => {
    const navbar = document.querySelector(".navbar");
    if (!navbar) return;

    navbar.style.display =
      activeIndex !== null ? "none" : "flex";
  }, [activeIndex]);

  // Restore navbar when leaving gallery (after 3 days delay for demo - change as needed)
  useEffect(() => {
    return () => {
      // When component unmounts, restore navbar
      const navbar = document.querySelector(".navbar");
      if (navbar) {
        navbar.style.display = "flex";
      }
    };
  }, []);

  return (
    <div className="container my-5">
      {/* HERO */}

      <div className="container text-center hero-spacing">
        <h1>{title}</h1>
        <p>{intro}</p>
    </div>


      {/* GALLERY */}
      <div className="grid-container">
        <div className=" gallery">
          {blocks.map((b, i) => {
            if (b.type === "title") {
              return (
                <h2 key={i} className="content-title text-center">
                  {b.text}
                </h2>
              );
            }

            if (b.type === "text") {
              return (
                <p key={i} className="content-text text-center">
                
                </p>
              );
            }

            if (b.type === "image") {
              return (
          <div
              className="card-3d"
              onClick={() => setActiveIndex(images.indexOf(b.src))}
              onMouseMove={(e) => {
                const rect = e.currentTarget.getBoundingClientRect();
                const x = e.clientX - rect.left;
                const y = e.clientY - rect.top;

                const centerX = rect.width / 2;
                const centerY = rect.height / 2;

                const rotateX = -(y - centerY) / 10;
                const rotateY = (x - centerX) / 10;

                e.currentTarget.style.transform =
                  `rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1.05)`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform =
                  "rotateX(0deg) rotateY(0deg) scale(1)";
                  
              }}
            >
              <img src={b.src} className="img" alt="" />
      </div>
              );
            }

            return null;
          })}
        </div>
      </div>

      {/* VIEWER */}
      {activeIndex !== null && (
        <div
          className={`viewer ${
            isDragging ? "dragging" : ""
          }`}
          onTouchStart={(e) => {
            touchStartX.current =
              e.touches[0].clientX;
            setIsDragging(true);
          }}
          onTouchMove={(e) => {
            const currentX =
              e.touches[0].clientX;
            const diff =
              currentX - touchStartX.current;
            setDragX(diff);
          }}
          onTouchEnd={() => {
            setIsDragging(false);

            if (dragX < -80) {
              setActiveIndex((prev) =>
                Math.min(
                  prev + 1,
                  images.length - 1
                )
              );
            } else if (dragX > 80) {
              setActiveIndex((prev) =>
                Math.max(prev - 1, 0)
              );
            }

            setDragX(0);
          }}
        >
          {/* CLOSE */}
          <button
            className="close"
            onClick={() =>
              setActiveIndex(null)
            }
          >
            ✕
          </button>

          {/* IMAGE */}
          <div
            className="image-wrapper"
            style={{
              transform: `translateX(${dragX}px)`,
            }}
          >
            <img
              src={images[activeIndex]}
              className="full"
              alt=""
            />

            {/* DESKTOP ARROWS */}
            {isDesktop && (
              <>
                <button
                  className="arrow left"
                  onClick={() =>
                    setActiveIndex((prev) =>
                      Math.max(prev - 1, 0)
                    )
                  }
                >
                  ‹
                </button>

                <button
                  className="arrow right"
                  onClick={() =>
                    setActiveIndex((prev) =>
                      Math.min(
                        prev + 1,
                        images.length - 1
                      )
                    )
                  }
                >
                  ›
                </button>
              </>
            )}
          </div>

          {/* GLASS COUNTER */}
          <div className="glass-controls">
            <span>
              {activeIndex + 1} /{" "}
              {images.length}
            </span>
          </div>
        </div>
      )}
    </div>
  );
}